// extracted by mini-css-extract-plugin
export default {"divider":"cart_consolidation_divider__u5URH"};